import React from "react";
import { StyledFlex } from "./Flex.styled";

export const Flex = (props) => {
	return <StyledFlex {...props} />;
};
